import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSave, faCaretLeft, faCaretRight } from '@fortawesome/free-solid-svg-icons';
import $ from 'jquery';
import Axios from 'axios';
import {Alert, Logout, DConnect, DecryptData, PostOptions} from '../../components/Config';

function TechnicalAssistance(props){
    const [registration, setRegistration] = useState(props.registration);
    const [position, setPosition] = useState(props.position);
    const [businessDetails, setBusinessDetails] = useState(props.businessDetails);
    const [dropdowns, setDropdowns] = useState({'development':[],'heard_about':[]});
    const [techAssist, setTechAssist] = useState(props.techAssistance);
    const [save, setSave] = useState(false);
    const [heardAbout, setHeardAbout] = useState(props.heardAbouts);

    const [techOther, setTechOther] = useState(props.techOther);

    useEffect(() => {
        props.getProps(props);
        setRegistration(props.registration);
        setBusinessDetails(props.businessDetails);
        setDropdowns(props.dropdowns);

    }, []);

  
    
    const handleChange = (e) => {
        const {name, value} = e.target;

        let tech =[...techAssist];

        if(['tech_assistance'].includes(name)){
            setBusinessDetails(prevState => ({
                ...prevState, [name]: value
            }));
        }else{
            if(e.target.checked && !tech.includes(parseInt(value))){
                if(tech.length <= 2) tech.push(parseInt(value)); 
            }else{
                let index = tech.indexOf(parseInt(value));
                if (index > -1){ tech.splice(index, 1); }
            }

            setTechAssist(tech);
        }
    }

    const handleOther = (e) => {

        const {name, value} = e.target;

        setTechOther(prevState => ({...prevState, [name]:value}))
    }

    const handleHeard = (e) => {
        const {name, value} = e.target;

        let heard =[...heardAbout];

        if(e.target.checked && !heard.includes(parseInt(value))){
            heard.push(parseInt(value)); 
        }else{
            let index = heard.indexOf(parseInt(value));
            if (index > -1){ heard.splice(index, 1); }
        }

        setHeardAbout(heard);
    }

    const submitForm = (e) => {
        e.preventDefault();
        if(businessDetails.tech_assistance == 1){
            if(techAssist.length == 0){
                Alert({title:'Provide Required Information',message:"Please provide all relevant Business Development areas...", buttons:[{label:'Ok'}]});
                return;
            }
        }
        if(heardAbout.length > 0){
        props.handleChange(0, businessDetails);
        let options = (businessDetails.id == 0) ? PostOptions('POST', businessDetails, 'business')
            : PostOptions('PUT', businessDetails, `business/${businessDetails.id}`);

        Axios(options).then(res => {
            let resdata = DecryptData(res.data);
            if (resdata.id !== undefined) {
                businessDetails['id'] = resdata.id;
                props.handleChange(0, businessDetails);
            }
        }).catch(error => { Alert({title:'Technical Assistance',message:error.message, buttons:[{label:'Ok'}]}); });

        props.handleChange(10, techAssist);
        props.handleChange(13, techOther);
        Axios(PostOptions('POST', techAssist, `techAssistDetails/bulk/${businessDetails.app_num}`)).then(res => {
            let resdata = DecryptData(res.data);

            //alert(JSON.stringify(resdata))
            let isOther = resdata.filter(rdata => rdata.assist_type == 11);
            if(isOther.length>0){
                let fdata = isOther[0];
                fdata.assist_other = techOther.development;
                Axios(PostOptions('PUT', fdata, `techAssistDetails/${fdata.id}`)).then(res => {});
            }
        }).catch(error => { Alert({title:'Technical Assistance',message:error.message, buttons:[{label:'Ok'}]}); });

        //alert(JSON.stringify(heardAbout));
        props.handleChange(11, heardAbout);
        Axios(PostOptions('POST', heardAbout, `grantHeardAbout/bulk/${businessDetails.app_num}`)).then(res => {
            let resdata = DecryptData(res.data);

            let isOther = resdata.filter(rdata => rdata.heard_type == 12);
            if(isOther.length>0){
                let fdata = isOther[0];
                fdata.heard_other = techOther.heardAbout;
                Axios(PostOptions('PUT', fdata, `grantHeardAbout/${fdata.id}`)).then(res => {});
            }
         
            position.app_num = registration.app_num;
            position.ma_stage = position.ma_stage < 8 ? 8: position.ma_stage;
            props.handleChange(14, position);
            options = (position.id == 0) ? PostOptions('POST', position, 'appstage')
            : PostOptions('PUT', position, `appstage/${position.id}`);
            Axios(options).then(resD => {
                let resData = DecryptData(resD.data); 

                if (resData.id !== undefined) {
                    position['id'] = resData.id;
                    props.handleChange(14, position);
                }
             })     
        }).catch(error => { Alert({title:'Heard About',message:error.message, buttons:[{label:'Ok'}]}); });
        if(save){
        Logout()
        window.location.reload()
        }else{
        props.doNavigate(props,8,1);
        }
      }else{
        Alert({title:'Provide Required Information',message:"Please provide information about how you heard about the COVID-19 Response Grant...", buttons:[{label:'Ok'}]});
      }
    }

    return(
        <div className="content">
            {(!registration.tourism || registration.reg_formerly == 1) ?
            <h5>Technical <span>{}Assistance</span></h5>
            :<h5>GETP Grant Programme<span>Information</span></h5>}
            <br />
            <form id="frmTechAssist" method="POST" onSubmit={submitForm}>
                <div className="row">
                    <div className="col-xs-12">
                    
                        <div className="form-group">
                            <label for="assist_type">Do you need Business Development Services?</label><span className="required">*</span>
                            <div className="form-check">
                                <div className="row pb-3">
                                    <div className="col-1"><input type="radio" name="tech_assistance" className="form-check-input form-control" style={{height:'20px'}} value="0" checked={businessDetails.tech_assistance ==0} onChange={handleChange} /></div>
                                    <div className="col-2"><label className="form-check-label" style={{lineHeight:'20px'}}> No</label></div>
                                    <div className="col-1"><input type="radio" name="tech_assistance" className="form-check-input form-control" style={{height:'20px'}} value="1" checked={businessDetails.tech_assistance ==1} onChange={handleChange} /></div>
                                    <div className="col-2"><label className="form-check-label" style={{lineHeight:'20px'}}> Yes</label></div>
                                </div>
                            </div>
                        </div>
                        {businessDetails.tech_assistance == 1 &&
                        <div className="form-group">
                            <label for="assist_type">Business development areas? <small>(Please select maximum of 3)</small></label>
                            <div className="row">
                                {dropdowns.development.map(dev => (
                                    <div className="col-xs-12 col-sm-6">
                                        <div className="row pb-2">
                                            <div className="col-2"><input type="checkbox" className="form-control" name="techAssist" value={dev.ivalue} checked={techAssist.includes(parseInt(dev.ivalue))} style={{height:'20px'}} onChange={handleChange}  /></div>
                                            <div className="col-10">
                                                <label style={{lineHeight:'20px'}}>{dev.iname} {dev.ivalue == '11' && '(specify)'}</label>
                                                {dev.ivalue == '11' && techAssist.includes(11) && <input className="form-control" name="development" id="development" value={techOther.development} onChange={handleOther} />}
                                            </div>
                                        </div>
                                    </div>
                                ))}
                                
                            </div>
                        </div>}
                            
                        <div className="form-group">
                            <label for="covid_response">How did you hear about the SME High-Growth Programme? <small>(Select all that applies)</small></label><span className="required">*</span>
                            <div className="row">
                                {dropdowns.heard_about.map(habout => (
                                    <div className="col-xs-12 col-sm-6">
                                        <div className="row pb-2">
                                            <div className="col-2"><input type="checkbox" className="form-control" name="heardAbout" value={habout.ivalue} checked={heardAbout.includes(parseInt(habout.ivalue))} style={{height:'20px'}} onChange={handleHeard}  /></div>
                                            <div className="col-10">
                                                <label style={{lineHeight:'20px'}}>{habout.iname} {habout.ivalue == '12' && '(specify)'}</label>
                                                {habout.ivalue == '12' && heardAbout.includes(12) && <input className="form-control" name="heardAbout" id="heardAbout" value={techOther.heardAbout} onChange={handleOther} />}
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                    
                </div>
            </form>
            <button className="btn btn-bg btn-outline text-white" style={{padding:'10px 20px',borderRadius: '20px', marginTop: '25px'}} onClick={() => props.doNavigate(props,6,0)}><FontAwesomeIcon icon={faCaretLeft} size="lg" /> &nbsp; Go Back </button>
            <button type="submit" form="frmTechAssist"  className="btn btn-bg btn-outline text-white float-right" style={{padding:'10px 20px', borderBottomRightRadius: '20px', borderTopRightRadius: '20px', marginTop: '25px'}}>Save &amp; Next &nbsp; <FontAwesomeIcon icon={faCaretRight} size="lg"  /></button>
            <button type="submit" form="frmTechAssist" onClick={()=>setSave(true)} className="btn btn-bg btn-outline text-white float-right" style={{ padding: '10px 20px', borderBottomLeftRadius: '20px', borderTopLeftRadius: '20px', marginRight: '5px', marginTop: '25px' }}>Save &amp; Close &nbsp; <FontAwesomeIcon icon={faSave} size="lg" /></button>
        </div>
    )
}

export default TechnicalAssistance;